import { 
    callApi,
    ACTION_ACCOUNTS_SET_TARGET_AMOUNT
} from "../apiIntegration";
import { notification } from 'antd';



const ACTIONS_METHODS = {
    [ACTION_ACCOUNTS_SET_TARGET_AMOUNT]: 'POST',
}

class ApiIntegration {
    constructor(props){
        this.data = props.data;
        this.action = props.action;
        this.notificationStatus = {
            200: "success",
            400: "error",
            401: "error"
        };
    }

    async call(){
        const apiResponse = await callApi({
            requireAuth: true,
            method: ACTIONS_METHODS[this.action],
            body: JSON.stringify(this.data),
            endpoint: `/api/v1/admin-functions/${this.action}/`,
            contentType: "application/json",
        })
        console.log(apiResponse);
        if (apiResponse.status === 200){
            notification.success({
                description: apiResponse.message,
            });
        } else {
            notification.error({
                description: apiResponse.message,
            });
        }
        return apiResponse;
    }
}

export default ApiIntegration;